import type React from 'react'
import type { ReportData } from './SummaryReport/ReportSection.js'
import { appliedSections } from './SummaryReport/sections/index.js'

/**
 * The printable metabarcoding summary. Which blocks appear, and what each says, is decided by the
 * order's {@link ReportData.profile}; see `SummaryReport/sections` for the blocks and
 * `Model/Order/processingProfile.ts` for the profile.
 */
const SummaryReport: React.FC<{ data: ReportData }> = ({ data }) => {
  if (data.order.processingType === 'EDNA') {
    throw new Error('SummaryPdfTailwind only supports metabarcoding orders.')
  }

  return (
    <div className="font-sans text-gray-900 print:visible invisible">
      <style>
        {`
          @media print {
            @page {
              size: A4;
              margin: 1cm;
            }
            body {
              -webkit-print-color-adjust: exact;
              print-color-adjust: exact;
            }
          }
        `}
      </style>

      {appliedSections(data.profile).map(({ id, Render }) => (
        <Render key={id} data={data} />
      ))}

      <footer className="fixed bottom-0 w-full text-xs text-gray-600 text-center">
        Spcfy GmbH | Niemeyerstraße 1, 04179 Leipzig | Lab: {data.orderLab?.name}
      </footer>
    </div>
  )
}

export default SummaryReport
